import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import Money from '../lib/Money';
import XBadge from '../lib/XBadge';
import { currencyName } from '../common/Helpers';

const AccountObligation = (props) => {
	const { obligations, address } = props;

	return (
		<div>
			<Table responsive>
				<thead>
					<tr>
						<th className="text-center">#</th>
						<th className="text-center">Type</th>
						<th className="text-left">Token name</th>
						<th className="text-left">Token code</th>
						<th className="text-right">Issued supply</th>
					</tr>
				</thead>
				<tbody>
					{ obligations.map((obligation, index) =>
					<tr key={index}>
						<td className="text-center">{index+1}</td>
						<td className="text-center">
							<XBadge variant="success">ISSUED TOKEN</XBadge>
						</td>
						<td className="text-left text-monospace">
							<Link to={`/token/${currencyName(obligation.currency)}.${address}`}>${currencyName(obligation.currency)}</Link>
						</td>
						<td className="text-left text-monospace">{obligation.currency}</td>
						<td className="text-right">
							<Money
								value={obligation.value}
								currency={obligation.currency}
								issuer={address}
							/>
						</td>
					</tr>
					)}
				</tbody>
			</Table>
		</div>
	);
}

AccountObligation.propTypes = {
	obligations: PropTypes.array.isRequired,
	address: PropTypes.string.isRequired,
}
export default AccountObligation;